module.exports = __webpack_public_path__ + "img/company_attestation.c2b9df34.png";